// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".css__container___18kN8 {\n\n}\n\n.css__centerContainer___36vXj {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  padding: 0 var(--content-h-padding);\n}\n\n.css__inner___38D5A {\n  max-width: var(--content-width);\n  width: 100%;\n  flex: 1;\n}\n\n.css__innerOverflow___3Rwk- {\n  max-width: var(--overflow-width);\n}\n\n.css__containerFull___2nXut {\n  flex: 1;\n  display: flex;\n  flex-direction: column\n}\n\n.css__containerFull___2nXut .css__centerContainer___36vXj {\n    flex: 1;\n  }\n\n.css__containerFull___2nXut .css__inner___38D5A {\n    display: flex;\n    flex-direction: column;\n  }", ""]);
// Exports
exports.locals = {
	"container": "css__container___18kN8",
	"centerContainer": "css__centerContainer___36vXj",
	"inner": "css__inner___38D5A",
	"innerOverflow": "css__innerOverflow___3Rwk-",
	"containerFull": "css__containerFull___2nXut"
};
module.exports = exports;
